'use strict';

module.exports = require('mapbox-gl-style-spec/reference/latest.min');



/*****************
 ** WEBPACK FOOTER
 ** ./~/mapbox-gl/js/style/style_spec.js
 ** module id = 394
 ** module chunks = 0
 **/